import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG } from './constants';
export function PricingCard() {
  return <section id="offer" className="border-y-2 border-brand-orange/40 bg-brand-light px-4 py-6" data-id="element-125" data-mp="1m3rot4ikhvhh">
      <div className="mx-auto max-w-2xl" data-id="element-126" data-mp="1i37q3wicijt8">
        <div className="mb-3 text-center" data-id="element-127" data-mp="1i4ahe5jkyo9o">
          <p className="mb-1 font-display text-[11px] font-semibold uppercase tracking-widest text-brand-orange sm:text-sm" data-id="element-128" data-mp="2esp5x4b1lm8n">
            Special Launch Offer
          </p>
          <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-129" data-mp="29vyp2ereymm6">
            SMART HOME INSTALLER PRO™
          </h2>
          <p className="mb-2 font-display text-sm font-semibold text-brand-ink sm:text-base" data-id="element-130" data-mp="210iq5jbsxh9q">
            Complete 6-in-1 Installation &amp; Business System
          </p>
          <a href={CHECKOUT_URL} className="block cursor-pointer" aria-label="Buy Smart Home Installer Pro" data-id="element-131" data-mp="2sszw054j2wsr">
            <img src={PRODUCT_IMG} alt="Smart Home Installer Pro 6-in-1 system box set" className="mx-auto mb-2 w-full max-w-[230px] object-contain drop-shadow-xl transition-transform duration-200 hover:scale-[1.02] sm:max-w-[260px]" data-id="element-132" data-mp="32jsrlgqnvlxb" />
          </a>
        </div>

        <div className="mb-3 rounded-2xl border-4 border-brand-orange bg-white p-4 text-center shadow-2xl sm:p-5" data-id="element-133" data-mp="2ssg75a76zy1b">
          <ul className="mb-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-0.5 text-sm font-semibold text-brand-ink" data-id="element-134" data-mp="2jtujj0mv5sto">
            <li data-id="element-135" data-mp="2ot7ds6g2e26a">✅ 6 Professional Modules</li>
            <li data-id="element-136" data-mp="2oquqrevg91md">✅ 5 Premium Bonuses</li>
          </ul>
          <p className="mb-1 text-sm font-medium text-brand-muted" data-id="element-137" data-mp="29wgb9ob3gacg">
            Regular Price: <span className="line-through" data-id="element-138" data-mp="2eu872tev0glx">$97</span>
          </p>
          <p className="font-display text-sm font-extrabold uppercase tracking-wide text-brand-orange sm:text-lg" data-id="element-139" data-mp="2ewkxluyonzal">
            🔥 TODAY ONLY: $27 USD
          </p>
          <p className="mb-3 text-xs font-medium text-brand-muted" data-id="element-140" data-mp="d23k7wc7w9i2">
            Secure payment in your local currency.
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-141" data-mp="bjv27b1v8k34">🚀 YES! I WANT MY COMPLETE SYSTEM</CTAButton>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-brand-ink sm:text-sm" data-id="element-142" data-mp="6phelutg3h90">
          <div className="flex items-center gap-1" data-id="element-143" data-mp="3tsm6aag1qapn">
            <StarIcon className="h-4 w-4 fill-brand-amber text-brand-amber" data-id="element-144" data-mp="3ttxb8dl89oic" />
            <span data-id="element-145" data-mp="uc7f2rq5b3ri">⭐⭐⭐⭐⭐ 4.9/5 — Verified Student Reviews</span>
          </div>
          <span className="hidden text-brand-line sm:inline" data-id="element-146" data-mp="penocsc9gyio">•</span>
          <div className="flex items-center gap-1" data-id="element-147" data-mp="kmnu9givgzu0">
            <ShieldCheckIcon className="h-4 w-4 text-brand-orange" data-id="element-148" data-mp="klcsfm8zm25j" />
            <span data-id="element-149" data-mp="gm3xwf64i08x">🛡️ 7-Day Money-Back Guarantee</span>
          </div>
        </div>
      </div>
    </section>;
}